import { useRef } from 'react';
import debounce from 'lodash/debounce';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';

export type InstitutionOption = OptionType<string | number>;

export interface SearchInstitutionsParams {
  clientId: string;
  term: string;
}

export const searchInstitutions = async ({
  clientId,
  term,
}: SearchInstitutionsParams): Promise<InstitutionOption[]> => {
  try {
    const { Data } = await authFetch(
      urlWithParams('/Consumer/AutoComplete/ListInstitutions', { clientId }),
      {
        method: 'POST',
        ...httpBodyOptions({ term: term || '' }),
      },
    );

    return Data.slice(0, 20).map(({ Value, Term }) => ({
      label: Term,
      value: Value,
    }));
  } catch (error) {
    console.error(error);

    return [];
  }
};

interface Params {
  clientId: string;
}

export const useSearchInstitutionsSelect = ({ clientId }: Params) => {
  const loadInstitutions = useRef(
    debounce((term, callback) => {
      searchInstitutions({ clientId, term }).then(opts => callback(opts));
    }, 300),
  ).current;

  return {
    loadInstitutions,
  };
};
